// components/GlobalModals.jsx

import React, { useState } from "react";

import Login from "../features/Login";
import PlansAndPricing from "../features/PlanAndPricing";
import SignUp from "../features/SignUp";
import { useModal } from "../context.js/ModalContext";

// import { useModal } from "../context/ModalContext";

const GlobalModals = () => {
	const {
		isLoginModalOpen,
		isSignUpModalOpen,
		isPlanModalOpen,
		closeLoginModal,
		closeSignUpModal,
		closePlanModal,
		handleOverlayClick,
		openLoginModal,
		openSignUpModal,
		openPlanModal,
	} = useModal();

	const [email, setEmail] = useState("");

	return (
		<>
			{isLoginModalOpen && (
				<div
					className='modal-overlay'
					onClick={(e) => handleOverlayClick(e, closeLoginModal)}>
					<div className='modal-container'>
						<Login
							openSignUpModal={openSignUpModal}
							closeLoginModal={closeLoginModal}
						/>
					</div>
				</div>
			)}
			{isSignUpModalOpen && (
				<div
					className='modal-overlay'
					onClick={(e) => handleOverlayClick(e, closeSignUpModal)}>
					<div className='modal-container'>
						<SignUp
							openPlanModal={openPlanModal}
							openLoginModal={openLoginModal}
							closeSignUpModal={closeSignUpModal}
							setEmail={setEmail}
						/>
					</div>
				</div>
			)}
			{isPlanModalOpen && (
				<div
					className='modal-overlay'
					onClick={(e) => handleOverlayClick(e, closePlanModal)}>
					<PlansAndPricing
						handleOverlayClick={(e) => handleOverlayClick(e, closePlanModal)}
						email={email}
					/>
				</div>
			)}
		</>
	);
};

export default GlobalModals;
